<template>
    <div class="container mescroll-touch">
        <div class="topff">
            <img src="../../assets/images/ketop.png" class="img" />
            <div class="tab">
                <div class="tabin" :class="active == 0 ? 'active' : ''" @click="tabchange(0)">系列专题</div>
                <div class="tabin" :class="active == 1 ? 'active' : ''" @click="tabchange(1)">优质好课</div>
            </div>
        </div>
        <div class="classlist">
            
        </div>

    </div>
</template>
<script>
export default {
    name: 'classlist',
    data() {
        return {
            active: 0
        }
    },
    components: {
    },
    created() {
        document.title = "精品课程";
    },
    methods: {
        tabchange(i) {
            let that = this;
            that.active = i
        }
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    background: rgb(247, 248, 252);
}

.topff {
    padding-bottom: 0.25rem;
    background: #fff;
    margin-bottom: .25rem;
}

.img {
    display: block;
    width: 95%;
    margin: auto;
    padding: 0.26rem 0;
}

.tab {
    background: #f5f6fa;
    display: flex;
    flex-direction: row;
    width: 55%;
    margin: auto;
    justify-content: space-around;
    border-radius: 50rem;
    padding: 0.1rem;
    font-size: .42rem;
    font-weight: bold;
    color: #6e6e96;
}

.tabin {
    width: 50%;
    text-align: center;
    padding: 0.1rem 0;
}

.active {
    background: #fff;
    border-radius: 50rem;
    color: #1d2a5a;
}
</style>